<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="msg-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal" v-if="!web_403"></div>
                <div class="dialog-wrapper">
                    <h5 class="title" v-html="config[type].title"></h5>
                    <div class="msg-view">
                        <p v-html="text || config[type].text"></p>
                    </div>

                    <div class="u-ctrl" v-if="!web_403">
                        <div class="u-btn ok" @click="closeModal"></div>                       
                    </div>                    
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>

.msg-modal{
    // position: relative;
    // width: 656px;
    // height: 337px;
    // background-image: url(~@/assets/images/modal/bg-modal-sm.png);  
}

.title{
    // width: 100%;
    // height: 42px;
    // margin: 0 auto 10px;
    // background-repeat : no-repeat;
    // background-position : center;
    
    // &.apply-success{
    //     background-image: url(~@/assets/images/modal/title-success.png); 
    // }

    // &.bind-error{
    //     background-image: url(~@/assets/images/modal/title-error.png); 
    // }
    font-size: 26px;
    color: #49392e;
    text-align: center;
    margin: 0 auto 20px;
}

.msg-view{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 140px;
    font-size: 20px;
    color: #3b3f3e;
    line-height: 1.8;
    text-align: center;
}

.u-ctrl .u-btn.ok{
    width: 205px;
    height: 55px;
    margin: 20px auto 0;
    background-image: url(~@/assets/images/modal/btn-ok.png);     
}


</style>

<style lang="scss">
.msg-view{
    b{
        color: #f95148;
    }    
}
</style>

<script>
export default {
    data () {
        return {
            visible : false,
            text : '',
            type : 'notice',
            web_403 : false,
            config : {
                'notice' : {
                    title : 'notice',
                },
                'cash' : {
                    title : 'cash',
                    text : '兑换的现金红包将在活动结束后的30个工作日内，发放至您填写的对应支付宝账号，请注意查收~',
                },
                'bind-error' : {
                    title : '助力失败',
                    text : '请稍后再试~',
                },
                'share-error' : {
                    title : '助力失败',
                    text : '请稍后再试~',
                },                
                'apply-success' : {
                    title : '助力成功',
                    text : '奖励已发放至军师邮箱或网页活动，请及时领取',
                },
                'apply-error' : {
                    title : '助力失败',
                    text : '请稍后再试~',
                },
                'error' : {
                    title : '助力失败',
                    text : '请稍后再试~',
                },
                'tbc' : {
                    title : '',
                    text : '敬请期待',                    
                }
            },
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
        this.$disableScroll();
    },
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$enableScroll();
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },            
        closeModal(){
            this.destroyElement()
        },       
    },    
}
</script>